"use client";
import "./globals.css";
import React from "react";
import ConnectionStatus from "./ConnectionStatus";
import Header from "./components/Header";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <Header />
      <main className="max-w-7xl mx-auto p-4">
        <ConnectionStatus />
      </main>
    </div>
  );
}

export default App;
